<template>
  <div>
    <nav class="navbar" :class="`navbar-${navbarStatus}`">
      <div class="container">
        <div class="nav-other">
          <div class="nav_item logo-homepage-box">
            <router-link :to="{ name: 'Home' }">{{ $t('navigation.home') }}</router-link>
          </div>
          <div class="nav_item solution-box" :class="getActive('solution-box')"
            @mouseover="handleMouseOver('solution-box')" @mouseout="handleMouseOut('solution-box')">
            <span>{{ $t('navigation.solution') }}</span>
            <SelectTool :selectList="solutionList" :is-show="solutionBol" @changeSelect="changeBusinessModel" />
          </div>
          <div class="nav_item join-now-box" :class="getActive('join-now-box')"
            @mouseover="handleMouseOver('join-now-box')" @mouseout="handleMouseOut('join-now-box')">
            <router-link :to="{ name: 'SettledPlatform' }">{{ $t('navigation.joinNow') }}</router-link>
          </div>
          <div class="nav_item about-us-box" :class="getActive('about-us-box')"
            @mouseover="handleMouseOver('about-us-box')" @mouseout="handleMouseOut('about-us-box')">
            <router-link :to="{ name: 'AboutUs' }">{{ $t('navigation.aboutUs') }}</router-link>
          </div>
        </div>
        <div class="multilingual-get-scheme-box">
          <div class="multilingual" @mouseover="updateSelectStatusShow('aboutUsBol')"
            @mouseout="updateSelectStatusClose('aboutUsBol')">
            <div class="icon_box">
              <svg-icon class-name="the-earth-icon" icon-class="the-earth" />
            </div>
            <SelectTool :selectList="aboutUsList" :is-show="aboutUsBol" @changeSelect="changeLanguage" />
          </div>
          <div class="get-scheme">
            <div class="get-scheme_box">
              <router-link :to="{ name: 'SubmitUserInfo' }">{{ $t('navigation.getScheme') }}</router-link>
            </div>
          </div>

          <div class="nav-menu" @click="updateSelectStatusShow('drawer')">
            <div class="icon_box">
              <svg-icon class-name="nav-menu-icon" icon-class="nav-menu" />
            </div>
          </div>

        </div>
        <GetScheme />
      </div>
    </nav>
    <!-- 菜单弹出层 -->
    <van-popup v-model="drawer" position="right" :style="{ width: '100%', height: '100%' }"
      @closed="handleDrawerClosed">
      <div class="mobile-drawer">
        <div class="drawer-header">
          <span class="brand">{{ $t('navigation.home') }}</span>
          <van-icon name="cross" size="25" color="#ffffff" style="cursor: pointer;"
            @click="updateSelectStatusClose('drawer')" />
        </div>

        <section class="drawer-section">
          <div class="drawer-section__title">{{ $t('navigation.solution') }}</div>
          <van-cell :title="$t('navigation.businessModel')" @click="handleBusinessModelClick" />
        </section>
        <van-divider />
        <section class="drawer-section">
          <div class="drawer-section__title">{{ $t('navigation.joinType') }}</div>
          <van-cell :title="$t('navigation.joinNow')" @click="goToRoute('SettledPlatform')" />
        </section>
        <van-divider />
        <section class="drawer-section">
          <div class="drawer-section__title">{{ $t('navigation.aboutUs') }}</div>
          <van-cell :title="$t('navigation.aboutUs')" @click="goToRoute('AboutUs')" />
        </section>
        <van-divider />
        <section class="drawer-section">
          <div class="drawer-section__title">{{ $t('navigation.languageChose') }}</div>
          <van-cell :title="$t('navigation.zh')" @click="switchLanguage('zh')" />
        </section>
        <van-divider />
        <div class="drawer-footer">
          <van-button type="primary" block round color="linear-gradient(135deg, #980608, #ff545b)"
            @click="handleGetScheme">
            {{ $t('navigation.getScheme') }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SelectTool from '@/components/tool/Select.vue'
import GetScheme from '@/layout/components/GetScheme.vue'
import { toVcModel } from '@/router/components/jumpTo'
import { mapGetters } from 'vuex'
import SvgIcon from './SvgIcon.vue'
export default {
  name: 'AppNavbar',
  components: {
    SelectTool,
    GetScheme,
    SvgIcon
  },
  computed: {
    ...mapGetters(['navbarStatus'])
  },
  data() {
    return {
      currentLang: this.$i18n.locale,
      isActive: '',
      solutionBol: false,
      solutionList: [], // 初始化为空数组（后续动态生成）
      aboutUsBol: false,
      aboutUsList: [],   // 初始化为空数组（后续动态生成）
      drawer: false  // 移动端右侧菜单弹窗
    }
  },
  watch: {
    '$i18n.locale'() {
      // 语言切换时重新生成翻译列表
      this.updateTranslationLists()
    }
  },
  created() {
    // 组件创建时初始化翻译列表（确保 i18n 已加载）
    this.updateTranslationLists()
  },
  methods: {
    changeBusinessModel(value) {
      switch (value.value) {
        case 'vcModel':
          if (this.$route.name !== 'VcModel') {
            toVcModel()
            break
          }
      }
    },
    // 新增：统一更新翻译列表的方法
    updateTranslationLists() {
      this.solutionList = [
        { label: this.$t('navigation.businessModel'), value: 'vcModel' }
      ]
      this.aboutUsList = [
        { label: this.$t('navigation.zh'), value: 'zh' }
      ]
    },
    updateSelectStatusShow(type) {
      this[type] = true
    },
    updateMenuStatus(type) {
      this[type] = true
    },
    updateSelectStatusClose(type) {
      this[type] = false
    },
    updateMenuStatusClose(type) {
      this[type] = false
    },
    handleBusinessModelClick() {
      this.changeBusinessModel({ value: 'vcModel' })
      this.drawer = false
    },
    goToRoute(name) {
      // 判断当前页面是否需要跳转
      if (this.$route.name !== name) {
        this.$router.push({ name })

      }
      this.drawer = false

    },
    handleGetScheme() {
      this.goToRoute('SubmitUserInfo')
    },
    switchLanguage(value) {
      this.changeLanguage({ value })
      this.drawer = false
    },
    handleDrawerClosed() {
      this.isActive = ''
    },
    changeLanguage({ value }) {
      if (this.$i18n.locale === value) {
        return
      }
      this.$i18n.locale = value
      localStorage.setItem('lang', value)
    },
    getActive(type) {
      let activeClassName = ''
      if (this.isActive && type !== this.isActive) {
        activeClassName = 'nav_item--active'
      }
      return activeClassName
    },
    handleMouseOver(type) {
      this.isActive = type
      if (type === 'solution-box') {
        this.updateSelectStatusShow('solutionBol')
      }
    },
    handleMouseOut(type) {
      this.isActive = ''
      if (type === 'solution-box') {
        this.updateSelectStatusClose('solutionBol')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$NavItemColor: rgb(237, 238, 240);
$NavItemColorActive: rgb(175, 179, 186);
$ButtonBackColor: #980608;

@media screen and (max-width: 768px) {
  .navbar {
    z-index: 999;
    position: fixed;
    top: 0.5rem;
    width: 100vw;
    color: $NavItemColor;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 3.6rem;

    a {
      text-decoration: none;
      /* 新增：去掉下划线 */
    }

    .container {
      margin: 0 auto;
      width: 80vw;
      display: flex;
      justify-content: space-between;
      padding: 0 0.7rem;
      border-radius: 2.6875rem;
      border: 1px solid #ececec1a;

      .nav-other {
        display: flex;
        gap: 2rem;


        .nav_item {
          color: $NavItemColor;
          cursor: pointer;
          transition: color 0.3s;
          padding: 0.5rem 0;

          a {
            color: $NavItemColor;
            transition: color 0.3s;
          }

        }

        .logo-homepage-box {
          position: relative;
          margin-left: 0.7rem;
        }

        .solution-box {
          display: none;
        }

        .join-now-box {
          display: none;
        }

        .about-us-box {
          display: none;
        }
      }

      .multilingual-get-scheme-box {
        display: flex;

        .get-scheme {
          display: flex;
          align-items: center;

          a {
            color: $NavItemColor;
          }

          .get-scheme_box {
            background-color: $ButtonBackColor ;
            font-size: 1rem;
            padding: 0 1rem;
            border-radius: 3rem;
            cursor: pointer;
            transition: all .3s ease-in-out;

            &:hover {
              background-color: $ButtonBackColor;
            }

          }
        }

        .multilingual {
          display: none;
        }

        .nav-menu {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0.5rem;
          position: relative;
          cursor: pointer;

          .icon_box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.3rem;
            height: 2.3rem;
            border-radius: 2.3rem;

            &:hover {
              background-color: rgba(237, 238, 240, .1);
            }

            .nav-menu-icon {
              font-size: 1.5rem;
              color: $NavItemColor;
            }
          }
        }
      }

    }
  }

  .navbar-black {
    .container {
      backdrop-filter: blur(1.5625rem);
      background-color: #abb4ca1a;
    }
  }

  .logo-homepage-box {
    a {
      color: $ButtonBackColor !important;
      font-weight: 1000 !important;
    }
  }

  .navbar-white {
    color: rgb(0, 0, 0);

    .container {
      background-color: #abb4ca1a;
      backdrop-filter: blur(1.5625rem);

      .nav-other {

        .nav_item {
          color: rgb(0, 0, 0);
          font-weight: 500;

          a {
            color: rgb(0, 0, 0);
            font-weight: 500;
          }
        }
      }

      .multilingual-get-scheme-box {
        .nav-menu {
          .icon_box {
            &:hover {
              background-color: rgba(0, 0, 0, .1);
            }

            .svg-icon {
              color: rgb(0, 0, 0);
            }
          }
        }
      }
    }

  }
}

.mobile-drawer {
  height: 100%;
  box-sizing: border-box;
  padding: 4rem 2.5rem 0 2.5rem;
  background-color: #050505;
  color: #ffffff;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 900;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  margin-left: 2rem;
}

.drawer-header .brand {
  color: #980608;
  letter-spacing: 0.05rem;
}

.drawer-section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.drawer-section__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #A2A6AC;
  margin-bottom: 0.2rem;
  margin-left: 1rem;
}

.drawer-footer {
  margin-top: 5rem;
}

::v-deep .van-popup {
  background: transparent;
}

::v-deep .van-cell-group--inset {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 0.75rem;
}

::v-deep .van-cell {
  background: transparent;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .van-cell :active {
  background: transparent;
  color: #980608;
  cursor: pointer;
}

::v-deep .van-cell__title {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: inherit;
  font-weight: 700;
  font-size: 1.2rem;
}

::v-deep .van-button {
  font-size: 1.2rem;
  font-weight: 600;
  height: 3rem;
  line-height: 3rem;
}

@media screen and (min-width: 769px) {
  .navbar {
    z-index: 999;
    position: fixed;
    top: 0.5rem;
    width: 100vw;
    color: $NavItemColor;
    font-size: 1rem;
    font-weight: bold;
    line-height: 2.6rem;

    a {
      text-decoration: none;
      /* 新增：去掉下划线 */
    }

    .container {
      margin: 0 auto;
      width: 80vw;
      display: flex;
      justify-content: space-between;
      padding: 0 0.7rem;
      border-radius: 2.6875rem;
      border: 1px solid #ececec1a;

      .nav-other {
        display: flex;
        gap: 2rem;

        .solution-box {
          position: relative;
        }

        .nav_item {
          color: $NavItemColor;
          cursor: pointer;
          transition: color 0.3s;
          padding: 0.5rem 0;

          a {
            color: $NavItemColor;
            //margin-right: 2rem;
            transition: color 0.3s;
          }

        }

        .nav_item--active {
          color: $NavItemColorActive !important;

          a {
            color: $NavItemColorActive !important;
          }

        }
      }

      .multilingual-get-scheme-box {
        display: flex;

        .get-scheme {
          display: flex;
          align-items: center;

          a {
            color: $NavItemColor;
          }

          .get-scheme_box {
            background-color: $ButtonBackColor ;
            padding: 0 1rem;
            border-radius: 3rem;
            cursor: pointer;
            transition: all .3s ease-in-out;

            &:hover {
              background-color: $ButtonBackColor;
            }

          }
        }

        .multilingual {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1.5rem;
          position: relative;
          cursor: pointer;

          .icon_box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.3rem;
            height: 2.3rem;
            border-radius: 2.3rem;

            &:hover {
              background-color: rgba(237, 238, 240, .1);
            }

            .the-earth-icon {
              font-size: 1.5rem;
              color: $NavItemColor;
            }
          }
        }

        .nav-menu {
          display: none;
        }
      }

      .logo-homepage-box {
        position: relative;
        margin-left: 0.7rem;
      }
    }
  }

  .navbar-black {
    .container {
      backdrop-filter: blur(1.5625rem);
      background-color: #abb4ca1a;
    }
  }

  .logo-homepage-box {
    a {
      color: $ButtonBackColor !important;
      font-weight: 1000 !important;
    }
  }

  .navbar-white {
    color: rgb(0, 0, 0);

    .container {
      background-color: #abb4ca1a;
      backdrop-filter: blur(1.5625rem);

      .nav-other {

        .nav_item {
          color: rgb(0, 0, 0);
          font-weight: 500;

          a {
            color: rgb(0, 0, 0);
            font-weight: 500;
          }
        }
      }

      .multilingual-get-scheme-box {
        .multilingual {
          .icon_box {
            &:hover {
              background-color: rgba(0, 0, 0, .1);
            }

            .svg-icon {
              color: rgb(0, 0, 0);
            }
          }
        }

        .nav-menu {
          display: none;
        }
      }
    }

  }
}
</style>
